"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const app_1 = require("./app");
const responseError = require("./common/responseError");
const addContentState_1 = require("./addContentState");
function getContentState({ studentId, contentId }) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            // generate query
            let contentStatesRef = yield app_1.app.firestore.collection('contentStates');
            contentStatesRef = contentStatesRef
                .where('studentId', '==', studentId)
                .where('contentId', '==', contentId);
            // get data
            const contentStateDocs = yield contentStatesRef.get();
            if (contentStateDocs.empty) {
                // create content state, if not exist
                const contentState = yield addContentState_1.default({ studentId, contentId });
                return contentState;
            }
            else {
                const results = contentStateDocs.docs.map(contentStateDoc => {
                    return Object.assign({ id: contentStateDoc.id }, contentStateDoc.data());
                });
                return results[0];
            }
        }
        catch (e) {
            throw new responseError.HttpsError(responseError.FunctionsErrorCode.invalid_argument, e.message);
        }
    });
}
exports.default = getContentState;
//# sourceMappingURL=getContentStates.js.map